// import $ from 'jquery';

const { $ } = window;

export default class MatchResult {
  constructor(carList) {
    this.carList = carList;
    this.$list = $('#match-result-content');
    this.$item = $('<article></article>').addClass('match-result-item');
    this.$itemblock = $('<div></div>').addClass('match-result-block');
    this.$img = $('<div></div>').addClass('result-image-wrap')
      .html('<picture class="result-picture"><img src="" alt=""></picture>');
    this.$imgbtn = $('<div></div>').addClass('result-action d-lg-none')
      .html('<a name="imgbtn" class="btn btn-outline-primary btn-block btn-icon-suffix px-8" href="#">了解更多<i class="icon icon-arrow"></i></a>');
    this.$content = $('<div></div>').addClass('result-content-wrap');
    this.$header = $('<header></header>').addClass('result-headline');
    this.$headerTitle = $('<div></div>').addClass('result-title-wrap')
      .html('<h4 class="result-title"></h4>');
    this.$headerPoint = $('<div></div>').addClass('result-point-wrap')
      .html('<span>速配指數</span><span class="score"></span>');
    this.$headerDetails = $('<div></div>').addClass('result-car-details')
      .html('<span class="price"></span> <span class="power">汽油</span>');
    this.$resultContent = $('<main></main>').addClass('result-content')
      .html('<div class="result-introduction"></div>');
    this.$footer = $('<footer></footer>').addClass('result-footer')
      .html('<div class="result-action d-none d-lg-block"><a class="btn btn-outline-primary btn-miw-elastic btn-icon-suffix" href="#">了解更多<i class="icon icon-arrow"></i></a></div>');
  }


  render() {
    this.$list.empty();
    let data; let $img; let $imgbtn;
    let $item;
    let $itemblock;
    let $content;
    let $header; let $headerTitle; let $headerPoint; let $headerDetails;
    let $resultContent;
    let $footer;
    let price;
    for (let i = 0; i < this.carList.length; i += 1) {
      data = this.carList[i];
      $img = this.$img.clone();
      $imgbtn = this.$imgbtn.clone();
      $item = this.$item.clone();
      $content = this.$content.clone();
      $header = this.$header.clone();
      $headerTitle = this.$headerTitle.clone();
      $headerPoint = this.$headerPoint.clone();
      $headerDetails = this.$headerDetails.clone();
      $resultContent = this.$resultContent.clone();
      $footer = this.$footer.clone();
      $itemblock = this.$itemblock.clone();
      price = '{A}~{B}萬'.replace('{A}', data.PRICEA.slice(0, -3)).replace('{B}', data.PRICEB.slice(0, -3));
      $img.children('picture.result-picture').children('img').attr('src', data.IMG).end();
      $img.children('picture.result-picture').children('img').attr('alt', data.CARSTY).end();
      $imgbtn.children('a').attr('href', `/showroom/${data.CARSTY}`).end();
      $headerTitle.children('h4.result-title').html(data.CARSTY).end();
      $headerPoint.children('span.score').text(`${data.MATCH}%`).end();
      $headerDetails.children('span.price').text(price).end();
      $headerDetails.children('span.power').text(data.ENG).end();
      $resultContent.children('div.result-introduction').html(`它最符合你的：${data.MEM}`).end();
      $footer.children('div').children('a').attr('href', `/showroom/${data.CARSTY}`).end();
      $img.append($imgbtn);
      $header.append($headerTitle).append($headerPoint).append($headerDetails);
      $content.append($header).append($resultContent).append($footer);
      $itemblock.append($img).append($content);
      $item.append($itemblock).appendTo(this.$list);
      // console.log(`img:${$img.html()}`);
      // console.log(`itemblock:${$itemblock.html()}`);
      // console.log(`item:${$item.html()}`);
      // console.log(`list:${this.$list.html()}`);
      // console.log(this.$list);
    }
  }
}
